








































































































import Vue from 'vue';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Component } from 'vue-property-decorator';
import { EstadoAuditoria } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { EstadoInterface } from '@/interfaces/Estado';
import { UsuariosInterface } from '@/interfaces/Usuarios';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  AgGridEvent,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
} from 'ag-grid-community';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import config from '@/config/index';
import { LoadingService } from '@/services/loadingService';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    DatePicker,
    TimePicker,
  },
})
export default class Auditoria extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.AuditoriaUsuarios;
  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];

  controller: string = 'Auditoria';
  localeText: any = config.agGridTextos;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  gridOptions: GridOptions;
  serverSide: any;
  agGridUtil: AgGridUtil;
  estadoGrillaVm: EstadoGrillaVm;
  dformat: any = '';
  isFormValid: boolean = false;

  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  search: string = '';
  usuarioId: number = store.state.userId;
  //   $snotify: any;
  readonly controllerUsuario: string = 'usuario';

  //FILTROS AUDITORIA
  eventos: any = [];
  usuarios: UsuariosInterface[] = [];
  filtroGrillaEvento: any = null;
  filtroGrillaUsuario: any = null;
  filtroGrillaFechaD = moment(new Date())
    .add(-7, 'days')
    .toISOString()
    .substr(0, 10);

  fechaDesde: any = moment(new Date()).add(-1, 'weeks');
  fechaHasta: any = moment();
  horaDesde: any = moment('00:00', 'HHmm');
  horaHasta: any = moment('23:59', 'HHmm');
  rut: any = [];
  usuarioSeleccionado: any = '';
  eventoSeleccionado: any = '';
  rutSeleccionado: any = '';
  audit: any = [];

  loadingService = new LoadingService();

  constructor() {
    super();

    this.estadoGrillaVm = {
      id: 0,
      grilla: '',
      usuarioId: this.usuarioId,
      funcionalidades: this.funcionalidad,
    };

    this.columnDefs = [
      {
        headerName: 'Usuario',
        field: 'usuario',
        width: 200,
        minWidth: 80,
        hide: true,
        resizable: true,
        sortable: true,
      },
      {
        headerName: 'Email',
        field: 'email',
        width: 200,
        minWidth: 80,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Evento',
        field: 'evento',
        width: 200,
        minWidth: 80,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Comentario',
        field: 'comentario',
        width: 200,
        minWidth: 80,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fecha_ingreso',
        width: 200,
        minWidth: 80,
        sortable: true,
        resizable: true,
        sort: 'desc',
      },
      {
        headerName: 'Cliente',
        field: 'cliente_nombre',
        width: 200,
        minWidth: 80,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Rut',
        field: 'rut_cliente',
        width: 200,
        minWidth: 80,
        sortable: true,
        resizable: true,
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5, //Solución Paginación
      cacheBlockSize: 5, //Solución Paginación
      paginationAutoPageSize: false,
      localeText: this.localeText,
      onGridReady: this.onGridReady,
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      onDragStopped: this.onDragStoppedEvent,
      onColumnVisible: this.onColumnVisibleEvent,
      onColumnPinned: this.onColumnPinnedEvent,
      blockLoadDebounceMillis: 350,
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }

  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData(this.audit);
  }

  validaNulo(item: any): boolean {
    if (item !== null && item !== undefined) return true;
    else return false;
  }

  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }

  async buscar() {
    const clientSession: any = config.getClienteSesion();
    this.loadingService.showLoading();
    try {
      const response = await this.axios.http.post(
        `Metabase/PostgenericA/usuario_aud/getAudit`,
        {
          clientid: clientSession,
          fecha_ini:
            this.fechaDesde.format('YYYY-MM-DD').toString() +
            ' ' +
            this.horaDesde.format('HH:mm:ss').toString(),
          fecha_fin:
            this.fechaHasta.format('YYYY-MM-DD').toString() +
            ' ' +
            this.horaHasta.format('HH:mm:ss').toString(),
          email:
            this.usuarioSeleccionado != null ? this.usuarioSeleccionado : '',
          event_type:
            this.eventoSeleccionado != null ? this.eventoSeleccionado : '',
          rut_cliente: this.rutSeleccionado != null ? this.rutSeleccionado : '',
        }
      );
      //   console.log(response.data.data);
      this.audit = response.data.data;
      this.gridApi.setRowData(this.audit);
    } catch (error) {
      this.$snotify.error('Ocurrió un error al obtener lista de Usuarios');
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async created() {
    await this.getUsuarios();
    await this.getClients();
    await this.getEventTypes();
    await this.buscar();
  }

  async getUsuarios() {
    const clientSession: any = config.getClienteSesion();
    this.loadingService.showLoading();
    try {
      const response = await this.axios.http.post(
        `Metabase/PostgenericA/usuario_aud/getUsuariosAsignar`,
        { clienteId: clientSession }
      );
      //   console.log(response.data.data);
      this.usuarios = response.data.data;
    } catch (error) {
      this.$snotify.error('Ocurrió un error al obtener lista de Usuarios');
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async getClients() {
    const clientSession: any = config.getClienteSesion();
    this.loadingService.showLoading();
    try {
      const response = await this.axios.http.post(
        `Metabase/PostgenericA/usuario_aud/getClientsRut`,
        {
          clienteId: clientSession,
        }
      );
      //   console.log(response.data.data);
      this.rut = response.data.data;
    } catch (error) {
      this.$snotify.error('Ocurrió un error al obtener lista de Usuarios');
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async getEventTypes() {
    const clientSession: any = config.getClienteSesion();
    this.loadingService.showLoading();
    try {
      const response = await this.axios.http.post(
        `Metabase/PostgenericA/usuario_aud/getTipoEventos`,
        { clienteId: clientSession }
      );
      //   console.log(response.data.data);
      this.eventos = response.data.data;
    } catch (error) {
      this.$snotify.error('Ocurrió un error al obtener lista de Usuarios');
    } finally {
      this.loadingService.hideLoading();
    }
  }

  onColumnVisibleEvent(event: ColumnVisibleEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  onColumnPinnedEvent(event: ColumnPinnedEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  onDragStoppedEvent(event: DragStoppedEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  //Cambia Propiedad de Filtro en Grilla
  changeSortingProperty(val: boolean) {
    const columns = this.columnDefs.filter((column: ColDef) => {
      return column.headerName !== '' && column.headerName !== 'Acciones';
    });
    columns.forEach((item: any) => {
      item.sortable = val;
    });
  }
  //---

  beforeDestroy() {
    this.agGridUtil.guardarEstadoGrilla().finally(() => {
      this.gridApi.destroy();
    });
  }

  get computedDateFormattedFechaD() {
    return this.formatDate(this.filtroGrillaFechaD);
  }

  formatDateTime(fecha: Date): string {
    if (!fecha) return null;
    return moment(fecha).format('DD/MM/YYYY HH:mm:ss');
  }

  formatDate(fecha: String): string {
    if (!fecha) return null;
    const [year, month, day] = fecha.toString().split('-');
    return `${day}/${month}/${year}`;
  }
}
